// extracted by mini-css-extract-plugin
export default {"container":"App_container__riHY4","main":"App_main__dwl8D","image":"App_image__ZHKoL","about":"App_about__MGN60","title":"App_title__oFzO2","content":"App_content__i-RuO"};